import React, {useEffect, useRef, useState} from "react";
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Row
} from "reactstrap";
import {connect, useSelector} from "react-redux";
import * as Yup from "yup";
import ReactJson from "react-json-view";
import Switch from "react-bootstrap-switch";
import { ErrorMessage, useForm } from "react-hook-form";
import {getStateByPath} from "../../../redux/selectors";


// components
import {confirmAlert} from "react-confirm-alert";
import Separator from "../../../components/Separator";
import {GenericButton} from "../../../components/buttons/customButtons";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import FirebaseTarget from "../../../components/firebaseTarget/firebaseTarget";
import { LogHistoryModal } from "../../../components/logHistory/logHistoryModal";

// labels
import { FORM, REQUIRED } from "../../../components/i18n/i18n";
import {TT_CLOSE, TT_DELETE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";

// actions
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// services & providers
import {paramSettingsService} from "../../../jwt/_services/hotel/paramsSettingsService";
import {setForm, setItem, setLoading, setViewMode} from "../../../redux/actions/generics/IndexedActions";

const ParamSettingsForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { app, editMode, domainObject } = componentState?.data || {};

    const [showHistoryModal, setShowHistoryModal] = useState(true);
    const [jsonValue, setJsonValue] = useState( '{}');
    const [stringValue, setStringValue] = useState( domainObject?.ps_value_max || '');
    const [showDetailedJson, setShowDetailedJson] = useState(false);
    const modalHistoryRef = useRef(null);

    useEffect(() => {
        try {
            if (domainObject?.ps_value_max)
                setJsonValue(JSON.parse(domainObject?.ps_value_max));
        } catch (ex) {
            console.log('Error parsing JSON ParamSettings value');
        }
    }, []);

    const showHistory = () => {
        setShowHistoryModal(true);
        modalHistoryRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        ps_key: Yup.string().required(REQUIRED)
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,
            ps_key   : domainObject?.ps_key,
            ps_value_max : domainObject?.ps_value_max,
            note  : domainObject?.note,
        }
    });

    const submitSwitch = (data) => {
        if (props.generalPropouse) {
            confirmSubmit(data);
        } else {
            onSubmit(data);
        }
    }

    const confirmSubmit = (data) => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) => {
            return <FirebaseTarget
                className={"paramSettings"}
                data={data}
                onSubmit={onSubmit}
                onClose={onClose}
            />
        }
    });

    const onSubmit = (data, fbData, _) => {

        let dataRequest = {
            item : {
                ...data,
                ps_value_max: stringValue
            }
        };

        if (props.generalPropouse) {
            dataRequest.noDb = fbData.noDb;
            dataRequest.allDb = fbData.allDb;
            dataRequest.existingDb = fbData.existingDb;

            fbData?.fbDataBase && fbData?.fbDataBase?.id && (dataRequest.fbDataBase = { id : fbData.fbDataBase.id });
        } else {
            dataRequest.fbDataBase = { id : app?.fbDataBase?.id }
        }
        
        // console.log(stringValue);
        // return;

        if (editMode) {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, paramSettingsService, id, dataRequest)
        } else {
            genericIndexedActions.save(path, paramSettingsService, dataRequest)
        }

        returnToList()
    };

    const confirmDelete = (data) => {
        return ConfirmDelete({
            path,
            remove : genericIndexedActions.delete,
            data : data,
            fbDataBaseId :  app?.fbDataBase?.id,
            service: paramSettingsService
        });
    };

    const returnToList = () => {
        reset();
        props.setItem(path, null);
        props.setForm(path, false, false, false);
        props.onClose();
    }

    return (<>
            <Form onSubmit={handleSubmit(submitSwitch)}>
                <Card className={'card-modal'}>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="far fa-edit mr-2"/>
                        {FORM}
                        <div className="top-right">
                            <GenericButton
                                style={'table'}
                                icon={'fa-save'}
                                toolTip={TT_SAVE}
                                permission={'add'}
                                type={'submit'}
                            />
                            {
                                editMode &&
                                <>
                                    <GenericButton
                                        style={'table'}
                                        toolTip={TT_HISTORY}
                                        icon={'fa-clock'}
                                        permission={'search'}
                                        onClick={showHistory}
                                    />
                                    <GenericButton
                                        style={'danger-secondary'}
                                        toolTip={TT_DELETE}
                                        icon={'fa-trash'}
                                        permission={'delete'}
                                        onClick={_ => confirmDelete(domainObject)}
                                    />
                                </>
                            }
                            <Separator/>
                            <GenericButton
                                style={'danger-secondary'}
                                toolTip={TT_CLOSE}
                                icon={'fa-times'}
                                permission={'search'}
                                onClick={returnToList}
                            />
                        </div>
                    </CardTitle>

                    <CardBody className={'card-body-modal'}>
                        <Row>
                            <Col md="9">
                                <FormGroup>
                                    <Label>Llave</Label>
                                    <Input
                                        type="text"
                                        name="ps_key"
                                        placeholder="Key"
                                        innerRef={register}
                                        className={(errors.ps_key ? ' is-invalid' : '')}
                                    />
                                    <ErrorMessage errors={errors} name="ps_key" component="div"
                                                  className="invalid-feedback"/>
                                </FormGroup>
                            </Col>
                            <Col md="3">
                                <FormGroup>
                                    <Label>Editar como:</Label><br/>
                                    <Switch animate={true} offText={"Cadena"} onText={"JSON"}
                                            innerRef={register}
                                            onChange={_ => setShowDetailedJson(!showDetailedJson)}
                                            value={showDetailedJson}/>
                                </FormGroup>
                            </Col>
                            {
                                !showDetailedJson ?
                                    <Col md="12">
                                        <FormGroup>
                                            <Label>Valor (String)</Label>
                                            <Input
                                                type="text"
                                                // name="ps_value_max"
                                                placeholder="Valor"
                                                innerRef={register}
                                                value={stringValue}
                                                onChange={e => {
                                                    setStringValue(e.target.value)

                                                    if (showDetailedJson) {
                                                        try {
                                                            let jsonObj = JSON.parse(e.target.value);
                                                            setJsonValue(jsonObj);
                                                        } catch (ex) {
                                                            console.log(ex)
                                                        }
                                                    }
                                                }}
                                            />
                                        </FormGroup>
                                    </Col> :
                                    <Col md="12">
                                        <FormGroup>
                                            <Label>Valor (JSON)</Label>
                                            <ReactJson src={jsonValue}
                                                       defaultValue={jsonValue}
                                                       name={'Valor'}
                                                       displayDataTypes={false}
                                                       collapsed={false}
                                                       onEdit={p => {
                                                           setStringValue(JSON.stringify(p.updated_src))
                                                           try {
                                                               setJsonValue(p.updated_src);
                                                           } catch (ex) {
                                                               console.log(ex)
                                                           }
                                                       }}
                                            />
                                        </FormGroup>
                                    </Col>
                            }
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup>
                                    <Label>Notas</Label>
                                    <Input
                                        type="textarea"
                                        name="note"
                                        placeholder="Nota"
                                        innerRef={register}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Form>
            {
                showHistoryModal && <LogHistoryModal
                    ref={ modalHistoryRef }
                    item={ domainObject }
                />
            }
        </>
    )
}


const mapStateToProps = _ => ({
})

const mapActionsToProps = ({
    setViewMode,
    setItem,
    setForm,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(ParamSettingsForm)